namespace SolovisGateway.Admin.BackendSettings {

    export class BackendSettingsControl extends Solovis.UI.BaseControl {

        constructor(options) {
            super(options);
        }

        public doRender() {
            var testMessageLink = $("<a>").text("Request Test Email To Self");
            testMessageLink.click(() => this._showRequestTestEmail());

            $("<div>").append(testMessageLink).appendTo(this.container);

            // Terms Of Service.
            var tosLink = $("<a>").text("Add New Terms Of Service");
            tosLink.click(() => this._showAddTermsOfServiceAsync());
            var previewCurrentTosLink = $("<a>").text("Preview Current Terms Of Service");
            previewCurrentTosLink.click(() => this._tryPreviewTermsOfServiceAsync());
            var clearTosLink = $("<a>").text("Clear All Terms Of Service");
            clearTosLink.click(() => this._tryClearAllTermsOfServiceAsync());

            let tosDiv = $("<div>").css("margin-top", "10px").append(tosLink).appendTo(this.container);
            tosDiv.append($("<span>").text(" | "));
            tosDiv.append(previewCurrentTosLink);
            tosDiv.append($("<span>").text(" | "));
            tosDiv.append(clearTosLink);

            var editThinkificSettingsLink = $("<a>").text("Thinkific Settings")
            editThinkificSettingsLink.click(() => this._showEditThinkificSettingsAsync());

            $("<div>").css("margin-top", "10px").append(editThinkificSettingsLink).appendTo(this.container);

            let globalConfigLink = $("<a>").text("Global Configuration");
            globalConfigLink.click(() => this._showDefaultGlobalConfigAsync());

            let globalConfigHelpLink = $("<a>").append($("<span class='fa fa fa-question-circle'>")).css("margin-left", "5px");
            globalConfigHelpLink.click(() => {
                Solovis.Site.HelpManager.showCustomHelpDialog({
                    text: "'Global Configuration' JSON contract is defined by SolovisGateway.AdminApi.Contracts.Config.GlobalConfigData."
                });
            });

            let globalConfigDiv = $("<div>").css("margin-top", "10px").append(globalConfigLink).appendTo(this.container);
            globalConfigDiv.append(globalConfigHelpLink);
            globalConfigDiv.append($("<p>").text("WARNING: Changing these settings MAY require restarting all nodes in cluster."));
        }

        private _showRequestTestEmail() {
            Solovis.UI.confirm("Send test email to self?", "Test Email", (confirmed) => {
                if (confirmed) {
                    Solovis.Rpc.invokeAndWait(
                        "~/Admin/BackendSettings/SendTestEmailToSelf",
                        {},
                        (response, success) => {
                            if (success) {
                                Solovis.UI.alert("Message send requested asynchronously, so you'll have to check logs for any failure messages.");
                            }
                        });
                }
            });
        }



        private async _showEditThinkificSettingsAsync(): Promise<void> {

            let thinkificSettingsResponse = await Solovis.Rpc.invokeAndWait("~/Admin/BackendSettings/GetThinkificSettings", {});

            let thinkificSettings = thinkificSettingsResponse.result;

            let formBuilderDiv = $("<div>");
            let formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formBuilderDiv,
                initialValues: thinkificSettings
            });           

            formBuilder.addEntry({
                name: "url",
                label: "Thinkific Url",
                editor: {
                    type: "text"
                }
            });

            formBuilder.addEntry({
                name: "apiKey",
                label: "Thinkific API Key",
                editor: {
                    type: "text",                    
                }
            });

            formBuilder.setupDone();

            let dialog = formBuilder.showAsDialog({
                title: "Thinkific Settings",

                desiredWidth: 600,
                desiredHeight: 500,

                showSaveCancel: true,

                saveCallback: () => {
                    let newThinkificSettings: any = formBuilder.getValues();                   

                    Solovis.Rpc.invokeAndWait(
                        "~/Admin/BackendSettings/SetThinkificSettings",
                        { thinkificSettings: newThinkificSettings },
                        (response, success) => {
                            if (success) {
                                dialog.close();
                            }
                        });

                    return false;
                }
            });
        }

        private async _showDefaultGlobalConfigAsync(): Promise<void> {
            let globalConfigResponse = await Solovis.Rpc.invokeAndWait("~/Admin/BackendSettings/GetDefaultGlobalConfigJsonAndVersion", {});

            let globalConfigResult = globalConfigResponse.result;
            let version = globalConfigResult.version;

            let configJson = globalConfigResult.configJson ? globalConfigResult.configJson : null;

            let jsonDialog = new Solovis.UI.Dialogs.JsonDialog({
                json: configJson,
                canEdit: true,
                autoIndentSpaces: 2,
                applyCallback: async (newJson) => {
                    let saveResponse = await Solovis.Rpc.invokeAndWait(
                        "~/Admin/BackendSettings/UpdateDefaultGlobalConfigJsonIfExpectedVersionMatches",
                        {
                            configJson: newJson,
                            expectedVersion: version
                        });

                    if (saveResponse.result === true) {
                        Solovis.UI.alert("Configuration has been updated.");
                        return true;
                    }
                    else {
                        Solovis.UI.alert("Configuration has been changed since editor was opened. You must cancel changes and try again.");
                        return false;
                    }
                }
            });
            jsonDialog.show();
        }

        private async _showAddTermsOfServiceAsync(): Promise<void> {
            let formDiv = $("<div>");

            let formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formDiv
            });

            formBuilder.addEntry({
                name: "contentHtml",
                label: "Terms Of Service",

                editor: {
                    type: "textarea",
                    textareaOptions: {
                        width: 500,
                        height: 500
                    }
                }
            })

            let dialog = formBuilder.showAsDialog({
                title: "Add New Terms Of Service",

                modal: true,

                showSaveCancel: true,
                saveButtonText: "Add",

                desiredWidth: 800,
                desiredHeight: 700,

                saveCallback: () => {
                    let contentHtml = formBuilder.getValueByName("contentHtml");
                    if (contentHtml) {
                        this._trySaveTermsOfServiceAsync(contentHtml, dialog);
                    }
                    return false;
                }
            });
        }

        private async _trySaveTermsOfServiceAsync(contentHtml, dialog: Solovis.UI.Dialog) {
            let message = "Are you sure? This will require all users to accept new terms of service on next login.";

            let confirmed = await Solovis.UI.confirmAsync(message, "Confirm Terms Of Service");
            if (confirmed) {
                await Solovis.Rpc.invokeAndWait("~/Admin/BackendSettings/AddNewTermsOfService", { contentHtml: contentHtml });
                dialog.close();
            }
        }

        private async _tryPreviewTermsOfServiceAsync() {          
          window.location.href = Solovis.resolveFullUrl("/Admin/BackendSettings/PreviewGatewayTermsOfService");
        }

        private async _tryClearAllTermsOfServiceAsync() {
            let message = "Are you sure? This will clear out all Terms Of Service entries and users will no longer be prompted to "
                + " accept any Terms Of Service. Have you exported all current Terms Of Service? This command exists only to disable "
                + " Terms Of Service on a gateway where it should never have been enabled in the first place.";

            let confirmed = await Solovis.UI.confirmAsync(message, "Clear Terms Of Service");
            if (confirmed) {
                await Solovis.Rpc.invokeAndWait("~/Admin/BackendSettings/ClearAllTermsOfService", {});                
            }
        }
    }

}